import React__default from 'react';
import classnames from 'classnames';
import { SelectionBoxRadio } from '../SelectionBoxRadio/SelectionBoxRadio.js';
import { TileLayout } from '../TileLayout/TileLayout.js';

const SunglassesRxableSelect = ({ className , items , selectedValue , onChange ,  })=>{
    return /*#__PURE__*/ React__default.createElement("fieldset", {
        className: classnames('sunglasses-rxable-select', className)
    }, items.map(({ value , label , iconName  })=>{
        return /*#__PURE__*/ React__default.createElement(SelectionBoxRadio, {
            key: value,
            name: "sunglasses-rxable-select",
            value: value,
            checked: selectedValue === value,
            onChange: ()=>onChange(value)
            ,
            "data-t": value
        }, /*#__PURE__*/ React__default.createElement(TileLayout, {
            title: label,
            iconName: iconName
        }));
    }));
};

export { SunglassesRxableSelect };
//# sourceMappingURL=SunglassesRxableSelect.js.map
